module.exports = __webpack_public_path__ + "static/img/pic1.232b055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic1.png
// module id = L9Ma
// module chunks = 20